"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addVariantDatasetToDistributorCatalog = void 0;
const routes_1 = require("../../routes");
const addVariantDatasetToDistributorCatalog = (client) => async (distributorId, payload) => {
    const response = await client.post(routes_1.ENDPOINTS.ADD_VARIANT_DATASET_TO_PARTNER_CATALOG.applyParams(distributorId), payload);
    return response.data;
};
exports.addVariantDatasetToDistributorCatalog = addVariantDatasetToDistributorCatalog;
